"use strict";

var txObjectProperties = ['from', 'to', 'data', 'value', 'gasPrice', 'gas'];
module.exports = hasTransactionObject;
function hasTransactionObject(args) {
  // bad/empty args: bad
  if (!Array.isArray(args) || args.length === 0) {
    return false;
  }
  var lastArg = args[args.length - 1];
  // missing or non-object: bad
  if (!lastArg) return false;
  if (typeof lastArg !== 'object') {
    return false;
  }
  // empty object: good
  if (Object.keys(lastArg).length === 0) {
    return true;
  }
  // txParams object: good
  var keys = Object.keys(lastArg);
  var hasMatchingKeys = txObjectProperties.some(function (value) {
    return keys.includes(value);
  });
  if (hasMatchingKeys) {
    return true;
  }
  // no match
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@metamask/ethjs-contract/lib/has-tx-object.js
// module id = 13
// module chunks = 0